import PropTypes from 'prop-types';
import { useScene } from '../hooks/useScene';
import Heading from './Heading';
import Link from './ui/Link';

function Envelope() {
	return (
		<div className="trial__envelope">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 81 55">
				<g clipPath="url(#trial-envelope-clip-path)">
					<rect width="81" height="55" fill="#EEEEF9" rx="8" />
					<rect width="70.598" height="70.598" fill="#F6F6FC" rx="4" transform="scale(1.0034 .9966) rotate(-45 -16.317 6.757)" />
				</g>
				<defs>
					<clipPath id="trial-envelope-clip-path">
						<rect width="81" height="55" fill="#fff" rx="8" />
					</clipPath>
				</defs>
			</svg>
		</div>
	);
}

function SwitchToDesktop() {
	return (
		<svg width="361" height="106" viewBox="0 0 361 106" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M318.736 1C324.703 1.00005 329.54 5.83857 329.54 11.8076V91.043C329.54 91.4346 329.518 91.8213 329.478 92.2021H339.902C343.5 92.2023 346.417 95.1201 346.417 98.7197V98.7236C346.417 102.323 343.5 105.241 339.902 105.241H177.516C173.917 105.241 171 102.323 171 98.7236V98.7197C171 95.1201 173.917 92.2024 177.516 92.2021H187.94C187.899 91.8213 187.877 91.4346 187.877 91.043V11.8076C187.877 5.83858 192.715 1.00006 198.682 1H318.736ZM198.682 5.69434C195.307 5.6944 192.57 8.43125 192.57 11.8076V91.043C192.57 91.4394 192.61 91.8267 192.682 92.2021H324.737C324.809 91.8268 324.848 91.4394 324.848 91.043V11.8076C324.848 8.43124 322.111 5.69438 318.736 5.69434H198.682Z"
				fill="#8487D6"
			/>
			<path
				d="M65.3526 88.3279C66.6425 88.3279 67.6882 87.2816 67.6882 85.9913V30.9218C67.6881 29.6316 66.6425 28.5856 65.3526 28.5856H38.1549C36.865 28.5856 35.819 29.6315 35.819 30.9218V85.9913C35.819 87.2816 36.8649 88.3279 38.1549 88.3279H65.3526ZM38.1549 93.0224C34.2731 93.0224 31.126 89.8743 31.126 85.9913V30.9218C31.126 27.0389 34.2731 23.8911 38.1549 23.8911H65.3526C69.2343 23.8912 72.3811 27.0389 72.3812 30.9218V85.9913C72.3812 89.8743 69.2344 93.0223 65.3526 93.0224H38.1549Z"
				fill="#8487D6"
			/>
			<path
				d="M51.9448 85.6917C53.6395 85.6917 55.0133 84.3174 55.0133 82.6222C55.0133 80.927 53.6395 79.5528 51.9448 79.5528C50.2501 79.5528 48.8763 80.927 48.8763 82.6222C48.8763 84.3174 50.2501 85.6917 51.9448 85.6917Z"
				fill="#8487D6"
			/>
			<path
				d="M127.751 40.9251C129.253 39.4225 131.66 39.3756 133.219 40.7845L133.367 40.9251L148.871 56.4339L133.367 71.9466C131.817 73.4981 129.302 73.4986 127.751 71.9476C126.2 70.3966 126.201 67.8818 127.751 66.3304L133.533 60.5443H108.289C106.096 60.5441 104.318 58.7653 104.318 56.5716C104.318 54.3779 106.096 52.6001 108.289 52.5999H133.806L127.751 46.5433L127.61 46.3948C126.202 44.8355 126.249 42.4279 127.751 40.9251Z"
				fill="#5053C4"
			/>
		</svg>
	);
}

export default function Verification({ data, emailAddress, getLabel, isMobile, reload, resendActivationEmail, setSceneData }) {
	useScene(isMobile ? 'mobile_verification' : 'verification', { data, setSceneData });

	return (
		<>
			<Heading
				title={getLabel(isMobile ? 'verification_mobile_heading' : 'verification_heading')}
				subtitle={getLabel(isMobile ? 'verification_mobile_subtitle' : 'verification_subtitle')}
			/>
			<div className="trial__verification">
				<div className="verification__illustration">{isMobile ? <SwitchToDesktop /> : <Envelope />}</div>
				<div className="verification__notice">
					<p className="text-subline text-subline--sm">{getLabel('verification_email_notice')}</p>
					<p className="h5">{emailAddress}</p>
					{!isMobile && (
						<Link onClick={reload} testId="nav-restart">
							{getLabel('verification_link_restart')}
						</Link>
					)}
				</div>
				<div className="verification__meta">
					<div>
						<p>{getLabel('verification_title_request_new')}</p>
						<p>{getLabel('verification_text_request_new')}</p>
						<small>
							<Link small={true} onClick={resendActivationEmail} testId="resend-activation-email">
								{getLabel('verification_link_request_new')}
							</Link>
						</small>
					</div>
					{data.pages.contact && (
						<div>
							<p>{getLabel('verification_title_contact')}</p>
							<p>{getLabel('verification_text_contact')}</p>
							<small>
								<Link href={data.pages.contact} testId="visit-contact-page">
									{getLabel('verification_link_contact')}
								</Link>
							</small>
						</div>
					)}
				</div>
			</div>
		</>
	);
}

Verification.propTypes = {
	data: PropTypes.object.isRequired,
	emailAddress: PropTypes.string.isRequired,
	getLabel: PropTypes.func.isRequired,
	isMobile: PropTypes.bool.isRequired,
	reload: PropTypes.func.isRequired,
	resendActivationEmail: PropTypes.func.isRequired,
	setSceneData: PropTypes.func.isRequired,
};
